// Removes blank attributes from an Object in Javascript
// https://stackoverflow.com/questions/286141/remove-blank-attributes-from-an-object-in-javascript
export function removeBlankAttributesInObject<T extends object>(object: T): T {
  return Object.fromEntries(
    Object.entries(object).filter(([, v]) => v || false),
  ) as T;
}
